import * as ActionTypes from './ActionTypes';
import { assign } from '../../shared/Assign';
import { IInvoiceProductTypeListItem, ISite } from './Types';

const initialState = {
    invoiceProductTypes: {
        list: [] as IInvoiceProductTypeListItem[],
        item: { name: '', site: undefined, sites: [] as ISite[] }
    }
};

export default function planEditorsReducer(
    state: any = initialState.invoiceProductTypes,
    action: { type: string; result: any }
): any {
    switch (action.type) {
        case ActionTypes.LIST_INVOICE_PRODUCT_TYPES_SUCCESS: {
            const newState = assign({}, state);
            newState.list = action.result;
            return newState;
        }

        case ActionTypes.LOAD_INVOICE_PRODUCT_TYPE_SUCCESS: {
            const newState = assign({}, state);
            newState.item = action.result;
            return newState;
        }

        case ActionTypes.GET_INVOICE_PRODUCT_TYPE_SUCCESS: {
            const newState = assign({}, state);
            newState.item = action.result;
            return newState;
        }

        case ActionTypes.CREATE_INVOICE_PRODUCT_TYPE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list, assign({}, action.result)];
            return newState;
        }

        case ActionTypes.EDIT_INVOICE_PRODUCT_TYPE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [
                ...newState.list.filter((x: any) => x.id !== action.result.id),
                assign({}, action.result)
            ];
            return newState;
        }

        case ActionTypes.DELETE_INVOICE_PRODUCT_TYPE_SUCCESS: {
            const newState = assign({}, state);
            newState.list = [...newState.list.filter((x: any) => x.id !== action.result)];
            return newState;
        }

        default:
            return state;
    }
}
